import { FC } from 'react';

enum TagTheme {
  'GREEN' = 'bg-green-light text-green',
  'BLUE' = 'bg-blue-light text-blue',
  'ORANGE' = 'bg-orange-light text-orange',
  'RED' = 'bg-red-light text-red',
  'PURPLE' = 'bg-purple-light text-purple',
  'PINK' = 'bg-pink-light text-pink',
}

export type ThemeKey = 'GREEN' | 'BLUE' | 'ORANGE' | 'RED' | 'PURPLE' | 'PINK';

interface TextProps {
  text: { name: string; theme: ThemeKey };
}

const Text: FC<TextProps> = (props) => {
  return (
    <div className='mb-16 flex w-80 justify-center xl:mb-5.5 xl:w-128 xl:justify-start '>
      <div
        className={`inline-flex w-auto flex-row items-center justify-start  rounded-xl px-4 py-3 text-rotatorSmall font-bold xl:px-8 xl:py-6 xl:text-rotator ${
          TagTheme[props.text.theme]
        }`}
      >
        {props.text.name}
      </div>
    </div>
  );
};

export default Text;
